/** Chemins de navigation de l'objet Package (mécanique de fiche par objet sur route). */

/** Base de la page "Configuration des offres commerciales". */
export const PACKAGE_ADMIN_BASE = '/admin/offres';

/** Onglet du dashboard correspondant au listing des packages. */
export const PACKAGE_TAB = 'package';

/** Listing des packages (onglet du dashboard). */
export const packageListPath = `${PACKAGE_ADMIN_BASE}?tab=${PACKAGE_TAB}`;

/** Fiche de création d'un package. */
export const packageCreatePath = `${PACKAGE_ADMIN_BASE}/package/new`;

/** Fiche d'édition d'un package. */
export const packageFichePath = (id: string | number): string =>
    `${PACKAGE_ADMIN_BASE}/package/${id}`;

/** Route enfant (relative à `admin/offres`) gérant création (`new`) et édition (`:id`). */
export const PACKAGE_FICHE_ROUTE = 'package/:id';
